export const EmployeeCareerTypeEnum = {
  Warning: { label: 'Warning', value: 'Warning' },
  Promotion: { label: 'Promotion', value: 'Promotion' },
  Grading: { label: 'Performance Based Grading', value: 'Grading' },
};
